import React, { useState } from "react";
import "../../css/Univers.css";
import carte from "../../components/carte.webp";
import ChoixRegion from "../../components/ChoixRegion";
import donneesCarte from "../../components/enigmes/regions.json";

const { defaultText, regions } = donneesCarte;

// Dimensions natives de carte.webp : les centres des régions sont en % de l'image
const LARGEUR_CARTE = 1500;
const HAUTEUR_CARTE = 960;
// Distance maximale (en pixels natifs) entre un clic et le centre d'une région
const RAYON_CLIC = 220;

const borner = (valeur, min, max) => Math.min(Math.max(valeur, min), max);

// Place le centre de la région au milieu du cadre, sans laisser voir au-delà des bords de la carte
const styleZoom = (region) => {
    if (!region) return { transform: "none" };
    const { zoom, centre } = region;
    const demiCadre = 50 / zoom;
    const x = demiCadre - borner(centre.x, demiCadre, 100 - demiCadre);
    const y = demiCadre - borner(centre.y, demiCadre, 100 - demiCadre);
    return { transform: `scale(${zoom}) translate(${x}%, ${y}%)` };
};

const regionLaPlusProche = (x, y) => {
    let plusProche = null;
    let distanceMin = RAYON_CLIC;
    regions.forEach((region) => {
        const dx = ((x - region.centre.x) * LARGEUR_CARTE) / 100;
        const dy = ((y - region.centre.y) * HAUTEUR_CARTE) / 100;
        const distance = Math.hypot(dx, dy);
        if (distance < distanceMin) {
            distanceMin = distance;
            plusProche = region;
        }
    });
    return plusProche;
};

const Univers = () => {
    const [region, setRegion] = useState(null);

    // Le rectangle de l'image suit le zoom : on retrouve directement le point cliqué en % de la carte
    const handleMapClick = (event) => {
        const rect = event.currentTarget.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        const cible = regionLaPlusProche(x, y);
        setRegion(cible && cible.id !== region?.id ? cible : null);
    };

    return (
        <div>
            <div className="espaceHaut"></div>
            <div className="fondParchemin">
                <h1>Univers</h1>
                <p>
                    C’est dans les confins de l’univers que Baryon, titanesque dragon noir, jaillit des profondeurs
                    d’Astolie. Puissante entité créatrice, il porta le vent, le feu et la glace à la planète qui le vit
                    naître. Jours après jours, années après années, décennies après décennies, il chercha quelle forme
                    il allait donner à ce monde nouveau. Ce n’est qu’après des siècles d’efforts qu’enfin, il créa une
                    œuvre à même de le fasciner : La vie.
                </p>

                <p>
                    Il fut sidéré de découvrir une création capable d’évoluer indépendamment de sa volonté. Captivé, il
                    ne put s’empêcher d’observer le développement de son œuvre. Plusieurs siècles durant, le colossal
                    dragon survola son monde, veillant sur lui et assistant avec émerveillement à sa transformation.
                    Hélas, malgré son ardent désir d’observer son œuvre évoluer encore, la présence du dragon finit par
                    s’éteindre le jour où celui-ci se figea à tout jamais, ne laissant qu’une imposante montagne comme
                    seul souvenir de son existence. Depuis ce jour, sa création fut livrée à elle-même.
                </p>
            </div>
            <br />

            <iframe
                className="videoUnivers"
                src="https://www.youtube.com/embed/Py8e-TJ3vR8?si=Kf_9oHoDybUI33Ef&amp;controls=0"
                title="Cinématique d'Astolie"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen>
            </iframe>

            <div className="app-container">
                <div className="map-container">
                    <img
                        src={carte}
                        alt="Carte d'Astolie"
                        className="map-image"
                        style={styleZoom(region)}
                        onClick={handleMapClick}
                    />
                </div>
                <div className="text-container">
                    <h2>{region ? region.title : defaultText.title}</h2>
                    {region?.blason && (
                        <img src={region.blason} alt={`Blason de ${region.title}`} className="blason-image" />
                    )}
                    <p>{region ? region.text : defaultText.text}</p>
                    <div className="region-navigation">
                        <ChoixRegion regions={regions} valeur={region} onChange={setRegion} />
                        <button
                            className={`btn btnOrange carteEntiere${region ? "" : " cache"}`}
                            onClick={() => setRegion(null)}
                            disabled={!region}
                        >
                            Afficher la carte entière
                        </button>
                    </div>
                </div>
            </div>
            <div className="text-center">
                <img src="/img/or-ne_A4.jpg" alt="or A4" style={{ maxWidth: "90vw", maxHeight: "90vh", height: "auto" }} />
            </div>
        </div>
    );
};

export default Univers;
